import { MAIN_CONFIG } from '../../../../config/main'
import CircleCheck from '../../SVG/CircleCheck'
import './application-radio-buttons.scss'

/**
 * Application form radio buttons
 * 
 * @param {object} props
 * @param {string} props.question
 * @param {string[]} props.options
 * 
 * @returns {ReactElement}
 */

export default function ApplictionJumpSection(props) {
  const {
    label,
    id,
    buttonSecondaryColor,
    active=false,
    stepStatus = '',
    submittedSteps = [],
    herokuId = ''
  } = props

  const applicationStatus = ['Draft', 'Prototype', 'Incomplete']
  const getColor = () => {
    if (active) {
      return buttonSecondaryColor
    }
    else if (!active && !applicationStatus.includes(stepStatus) && submittedSteps.length < 1) {
      return MAIN_CONFIG.COLORS.fillGreen;
    }
    else if (!active && submittedSteps.includes(herokuId)) {
      return MAIN_CONFIG.COLORS.fillGreen;
    }
    return 'white'
  }
  
  return (
    <ul className="application-radio-buttons jump-to-section">
      <li
        className="application-radio-buttons__item"
        key={id}
      >
        <label className="application-radio-buttons__label" style={{fontFamily:active?'Inter-SemiBold':'Inter-Medium'}}>
        <div className='label-content'>
          {label}
          </div>
          <div className="application-radio-buttons__visualization">
            <CircleCheck id={id} className="application-radio-buttons__icon" color={getColor()} />
          </div>
        </label>
      </li>
    </ul>
  )
}
